// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroOutlinedSvg from "@fishx/icons-svg/es/asn/EuroOutlined";
import FishxIcon from '../components/FishxIcon';

var EuroOutlined = function EuroOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroOutlinedSvg
  }));
};

EuroOutlined.displayName = 'EuroOutlined';
export default React.forwardRef(EuroOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EuroOutlined.js
// module id = 2615
// module chunks = 0